<template>
  <div id="payFormInfo">
    <div class="title">{{ $t("TraderInformation.title") }}</div>
    <div class="info-view">
      <div class="icon"><img src="@/assets/images/svg/user.svg" alt="" /></div>
      <div class="info">
        <span>{{ showInfo }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "PayFormInfo",
  props: ["name", "idNumber", "phone"],
  computed: {
    ...mapState("userInfo", {
      userPayFormInfo: (state) => state.userPayFormInfo,
    }),
    /**
     * name、idNumber、phone 为 userPayFormInfo 中存放信息键值名
     * @returns {string}
     */
    showInfo() {
      const result = {};
      const iterate = (obj, prefix = "") => {
        for (const key in obj) {
          const newKey = prefix ? `${key}` : key;
          if (typeof obj[key] === "object" && obj[key] !== null) {
            iterate(obj[key], newKey); // 递归调用，处理嵌套对象
          } else {
            result[newKey] = obj[key];
          }
        }
      };
      iterate(this.userPayFormInfo);
      if (result[this.name] !== undefined && this.name) {
        return result[this.name].substring(0, 4) + "****";
      }
      if (result[this.idNumber] && this.idNumber) {
        return result[this.idNumber].toString().substring(0, 4) + "****";
      }
      if (result[this.phone] && this.phone) {
        return result[this.phone].toString().substring(0, 4) + "****";
      }
      return "";
    },
  },
};
</script>

<style scoped lang="scss">
#payFormInfo {
  margin-top: 0.24rem;
  .title {
    color: #6e7687;
    font-family: SF Pro Display;
    font-size: 0.13rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .info-view {
    display: flex;
    align-items: center;
    height: 0.56rem;
    border-radius: 0.12rem;
    background: #f4f5f7;
    margin-top: 0.08rem;
    padding: 0 0.16rem;
    .icon {
      width: 0.2rem;
      height: 0.2rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .info {
      margin-left: 0.08rem;
      color: #6e7687;
      font-family: SF Pro Display;
      font-size: 0.16rem;
      font-style: normal;
      font-weight: 400;
      line-height: 0.2rem;
    }
  }
}
</style>
